import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';
import {SidebarOptions} from '../../models';
import {ScreenSizeService} from '../../services';

/**
 * Footer service to retrieve versioning of frontend and backend to display
 */
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarOptions: BehaviorSubject<SidebarOptions> = new BehaviorSubject({isOpened: true, hasSidebar: true});
  public castIsOpened: Observable<SidebarOptions> = this.sidebarOptions.asObservable();

  constructor(private screenSizeService: ScreenSizeService) {
    this.screenSizeService.castCurrentScreenSize.pipe(distinctUntilChanged())
      .subscribe((size: string) => {
        if (size === 'desktop') {
          this.setSidebar({isOpened: true, hasSidebar: this.hasSidebar});
        } else {
          this.setSidebar({isOpened: false, hasSidebar: this.hasSidebar});
        }
      });
  }

  /**
   * Toggles the sidebar to true or false value
   */
  public toggleSidebar(): void {
    const value = !this.sidebarOptions.getValue().isOpened;
    this.sidebarOptions.next({isOpened: value, hasSidebar: this.hasSidebar});
  }

  /**
   * Sets the sidebar to the value you have provided
   */
  public setSidebar(options: SidebarOptions): void {
    this.sidebarOptions.next(options);
  }

  get isOpened(): boolean {
    return this.sidebarOptions.getValue().isOpened;
  }

  get hasSidebar(): boolean {
    return this.sidebarOptions.getValue().hasSidebar;
  }

}
